import { jsx } from "react/jsx-runtime";
import {
  TimePicker as TimePickerComponent
} from "../../../../components/TimePicker/index.js";
import { useTidalFormBridge } from "../../utils/useTidalFormBridge.js";
import { FormUIFormControl } from "../primitives/FormUIFormControl.js";
const noopOnValidate = () => {
};
const defaultComponentValue = null;
function TimePicker(props) {
  const {
    name,
    label,
    onValidate = noopOnValidate,
    initialValue = null,
    onValidateOptions,
    timePickerProps,
    ...bridgeOptions
  } = props;
  const {
    config: { fullWidth, testId = "textfield-root" },
    fieldInfo: {
      errorOrHelperText,
      field: { required, visible },
      fieldDisabled,
      fieldHasError,
      onChange,
      errorText,
      value
    }
  } = useTidalFormBridge({
    ...bridgeOptions,
    initialValue,
    validateOn: "change",
    label,
    name
  });
  if (!visible) return null;
  const handleOnChange = (value2) => {
    onChange(value2);
  };
  return /* @__PURE__ */ jsx(
    FormUIFormControl,
    {
      "data-testid": testId,
      "data-tidal": "TimePicker",
      fullWidth,
      "data-tidal-form-field-name": name,
      sx: {
        "&.tidal-form-devtool-highlight": (theme) => ({
          outline: `4px solid var(--tidal-devtools-highlight-color, ${theme.vars.palette.error.dark})`
        })
      },
      children: /* @__PURE__ */ jsx(
        TimePickerComponent,
        {
          error: errorText,
          required,
          disabled: fieldDisabled,
          ...timePickerProps,
          name,
          label,
          value,
          onChange: handleOnChange,
          errorVisibility: props.errorVisibility
        }
      )
    }
  );
}
export {
  TimePicker
};
//# sourceMappingURL=TimePicker.js.map
